export default Object.freeze([
    { name: 'Active', value: 1 },
    { name: 'Inactive', value: 0 }
]);
